import * as React from 'react';
export const AssetPathContext = /*#__PURE__*/React.createContext(() => '');